import produce from 'immer';
import { Banner } from 'client/components/Banner';
import { Stack } from 'client/components/Stack';
import {
  getProjectOrDeploymentState,
  type ProjectOrDeploymentState,
  useProjectOrDeployment,
  useProjectOrDeploymentProjectID,
  useProjectOrDeploymentState,
} from '../sectionsUtils';
import { RepositoryCatalog } from './RepositoryCatalog';
import { type RepositoryCatalogRepositoryBranch } from './RepositoryCatalogItem';

export const Repository = ({ forceBranchPicker }: { forceBranchPicker?: boolean }) => {
  const view = useProjectOrDeployment();
  const projectID = useProjectOrDeploymentProjectID();
  const stageIdentifier = useProjectOrDeploymentState((state) => state.document?.stage);
  const repositoryRef = useProjectOrDeploymentState((state) => state.document?.repositoryRef);

  const isProject = view === 'project';
  const isDevelopment = !forceBranchPicker && stageIdentifier === 'development';

  const handleBranchChange = (branch: RepositoryCatalogRepositoryBranch | null) => {
    if (isProject) return;
    if (isDevelopment) return;

    getProjectOrDeploymentState().setState(
      produce((state: ProjectOrDeploymentState) => {
        if (!branch) return;
        if (!state.document) return;
        if (!state.document.repositoryUrl) return;

        state.document.repositoryRef = branch.name;

        return state;
      })
    );
  };

  return (
    <Stack>
      <RepositoryCatalog
        projectID={projectID}
        repositoryRef={repositoryRef || null}
        onChangeBranch={!isDevelopment ? handleBranchChange : undefined}
      />

      {isDevelopment && (
        <Banner>
          This deployment is in development mode, which doesn't allow changing Git branches from here. SSH into the deployment to change the
          branch.
        </Banner>
      )}
    </Stack>
  );
};
